import log from '~/utils/log';

/**
 * Ensures the destination route is only accessible with an active Keycloak
 * session represented by a valid decoded ID token (`useAuth`).
 *
 * Flow:
 * - If already authenticated, continue navigation.
 * - If not authenticated but an ID token cookie exists, try `/api/auth/refresh`
 *   once for the current route.
 * - If refresh is not possible or already attempted, run pre-login hooks and
 *   redirect to `/api/auth/login`.
 *
 * @param to Destination route that is being entered.
 * @returns Redirect navigation to refresh/login when authentication is missing.
 */
export default defineNuxtRouteMiddleware(async (to) => {
    if (import.meta.server) return;

    const { redirectToLogin, removeRefreshAttempt } = useRedirectToLogin();
    const { isKeycloakAuthenticated } = useLoginState();
    const refreshAttemptStateKey = 'require-login-keycloak:refresh-attempted';

    if (isKeycloakAuthenticated.value) {
        removeRefreshAttempt(refreshAttemptStateKey, to.fullPath);
        return;
    }

    log.debug('[require-login-keycloak.ts] Redirecting to login.');
    return redirectToLogin({
        to,
        refreshAttemptStateKey
    });
});
